import React from 'react';
import CostTableOverview from './CostTablesOverview/CostTableOverview';
import CostTableDetails from './CostTableDetails/CostTableDetails';
import LanguageIcon from '@mui/icons-material/Language';
import { addRouteNamespace } from '@Utils/actions';

export const mainPageRoutes = [
  {
    title: 'Cost Table Details',
    to: addRouteNamespace(':costTableId'),
    render: <CostTableDetails />,
  },
];

export const miniPageRoutes = [
  {
    title: 'Cost Tables',
    to: '/cost-tables',
    icon: <LanguageIcon />,
    render: <CostTableOverview />,
  },
  ...mainPageRoutes,
];

const pageRoutes = [mainPageRoutes, miniPageRoutes];
export default pageRoutes;
